import {
  deleteToken,
  getMessaging,
  getToken as getTokenCore,
  isSupported,
} from "firebase/messaging";
import { config, vapidKey } from "./config";
import { initializeApp } from "firebase/app";
import { useCallback, useMemo } from "react";
import { useFirebaseSubscriptionStorage } from "./use-firebase-subscription-storage";
import { getInstallations, getId } from "firebase/installations";

export function useFirebaseMessaging() {
  const { save, remove, token } = useFirebaseSubscriptionStorage();

  const app = useMemo(() => initializeApp(config), []);

  const getToken = useCallback(async () => {
    if (!(await isSupported())) {
      return;
    }

    const messaging = getMessaging(app);
    return getTokenCore(messaging, { vapidKey });
  }, [app]);

  const unsubscribe = useCallback(async () => {
    if (!(await isSupported())) {
      return;
    }

    const messaging = getMessaging(app);
    await deleteToken(messaging);
    remove();
  }, [app, remove]);

  const getInstallationId = useCallback(async () => {
    const installations = getInstallations(app);
    const id = await getId(installations);
    return id;
  }, [app]);

  return {
    getToken,
    unsubscribe,
    getInstallationId,
    token,
    save,
  };
}
